export default __webpack_public_path__ + "static/4F_CIRCULARITY-b0621264a1b5fa959fece5053777beb4.png";